import React, { useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import Modal from './Modal';
import { cancelSubscription } from '../../Shared/Api';
import { formatBillingDate } from '../../Pages/Settings/constants';

const CancelSubscriptionModal = ({
	open,
	onClose,
	onSuccess,
	enqueueSnackbar,
	periodEnd,
}) => {
	const [submitting, setSubmitting] = useState(false);
	const periodEndLabel = formatBillingDate(periodEnd);

	const handleConfirm = async () => {
		setSubmitting(true);
		try {
			await cancelSubscription();
			enqueueSnackbar?.(
				'Subscription scheduled to cancel at the end of your billing period.',
				{ variant: 'success' },
			);
			onSuccess?.();
			onClose?.();
		} catch (error) {
			enqueueSnackbar?.(error.message || 'Could not cancel subscription.', {
				variant: 'error',
			});
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
			modalTitle="Cancel subscription"
			maxWidth="sm"
			useActionButtons
			actionButtons={
				<>
					<Button onClick={onClose} disabled={submitting}>
						Keep subscription
					</Button>
					<Button
						variant="contained"
						color="warning"
						onClick={handleConfirm}
						disabled={submitting}
					>
						{submitting ? 'Canceling...' : 'Cancel at period end'}
					</Button>
				</>
			}
		>
			<Box sx={{ mt: 1 }}>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					You keep full access until
					{periodEndLabel
						? ` ${periodEndLabel}`
						: ' the end of your billing period'}
					. After that, your subscription ends and your data is retained for 30
					days.
				</Typography>
				<Alert severity="warning">
					You can reactivate anytime before the period ends from Settings ?
					Billing.
				</Alert>
			</Box>
		</Modal>
	);
};

export default CancelSubscriptionModal;
